import axios from "axios";
import { MERCHANT_CODE } from "@/lib/tenant";
import { backendBaseUrl } from "./backendUrl";
import { installRequestLoader } from "./requestLoader";

// Public requests need merchant routing, but must not reuse a stored staff token.
const publicApi = axios.create({ baseURL: `${backendBaseUrl()}/api` });
publicApi.interceptors.request.use(config => {
  if (MERCHANT_CODE && !config.skipMerchantCode) config.headers["X-Merchant-Code"] = MERCHANT_CODE;
  return config;
});

installRequestLoader(publicApi);
export default publicApi;
